module.exports = __webpack_public_path__ + "img/hr-green-pita-mini-09.210f3a6d.png";